const environment = {
    baseUrl : "lexique-univ.uclouvain.be",
    port : 443,
    terminoUniv : {
        trad : "/api/terminouniv/trad",
        partialMatch : "/api/terminouniv/partialmatch",
        frequentExpr : "/api/terminouniv/frequentexpr",
        suggestions : "/api/terminouniv/suggestions"
    },
    translationAssistant : "/api/translateassist",
    suggestions : "/api/suggestions",
    tip : "/api/tip"
}

export default environment
